'use strict';

import * as resourcePackList from '../actions/resourcePackList';

var defaultState = {
    isNewResourcePackOverlayOpen: false,
    isDeleteResourcePackOverlayOpen: false,
    isEditResourcePackOverlayOpen: false,
    packToEdit: null,
    packToDelete: null,
    packs: [],
    filesToAdd: [],
    searchResults: []
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case resourcePackList.HIDE_EDIT_RESOURCE_PACK_OVERLAY:

            return {
                ...state,
                isEditResourcePackOverlayOpen: false
            };

        case resourcePackList.SHOW_EDIT_RESOURCE_PACK_OVERLAY:

            return {
                ...state,
                isEditResourcePackOverlayOpen: true,
                packToEdit: action.pack
            };

        case resourcePackList.SHOW_DELETE_RESOURCE_PACK_OVERLAY:

            return {
                ...state,
                isDeleteResourcePackOverlayOpen: true,
                packToDelete: action.pack
            };

        case resourcePackList.HIDE_DELETE_RESOURCE_PACK_OVERLAY:

            return {
                ...state,
                isDeleteResourcePackOverlayOpen: false
            };

        case resourcePackList.RESOURCES_PACKS_REFRESHED:

            return {
                ...state,
                packs: action.packs
            };

        case resourcePackList.RESOURCES_PACK_REMOVE_FILE_TO_ADD:

            const files = state.filesToAdd.filter((file, index) => {

                return index !== action.fileIndex;
            });

            return {
                ...state,
                filesToAdd: files
            };

        case resourcePackList.RESOURCES_PACK_FILES_ADDED:

            return {
                ...state,
                filesToAdd: state.filesToAdd.concat(action.files)
            };

        case resourcePackList.NEW_RESOURCE_PACK_OVERLAY_TOGGLED:

            return {
                ...state,
                isNewResourcePackOverlayOpen: !state.isNewResourcePackOverlayOpen
            };

        case resourcePackList.UPDATE_RESOURCE_PACK_SEARCH_RESULTS:

            return {
                ...state,
                searchResults: action.searchResults
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/resourcePackList.js